// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"bd1c42b9","878":"54a68230"}[chunkId] + ".chunk.js";
};